import { SalarioType } from '../../../types/applicant/commons'
import {
  GetPreferenciaSalarial,
  GET_PREFERENCIA_SALARIAL,
  UpdatePreferenciaSalarial,
  UPDATE_PREFERENCIA_SALARIAL,
  UpdatePreferenciaSalarialReset,
  UPDATE_PREFERENCIA_SALARIAL_RESET,
  DeletePreferenciaSalarial,
  DeletePreferenciaSalarialReset,
  DELETE_PREFERENCIA_SALARIAL,
  DELETE_PREFERENCIA_SALARIAL_RESET,
} from '../../../types/applicant/curriculum/preferencia-salarial'

export const getPreferenciaSalarial = (): GetPreferenciaSalarial => {
  return {
    type: GET_PREFERENCIA_SALARIAL,
    payload: null,
  }
}

export const updatePreferenciaSalarial = (datos: SalarioType): UpdatePreferenciaSalarial => {
  return {
    type: UPDATE_PREFERENCIA_SALARIAL,
    payload: datos,
  }
}

export const updatePreferenciaSalarialReset = (): UpdatePreferenciaSalarialReset => {
  return {
    type: UPDATE_PREFERENCIA_SALARIAL_RESET,
    payload: null,
  }
}

export const deletePreferenciaSalarial = (): DeletePreferenciaSalarial => {
  return {
    type: DELETE_PREFERENCIA_SALARIAL,
    payload: null,
  }
}

export const deletePreferenciaSalarialReset = (): DeletePreferenciaSalarialReset => {
  return {
    type: DELETE_PREFERENCIA_SALARIAL_RESET,
    payload: null,
  }
}
